<script>
import {nextTick} from "vue";
import default_img from "@img/defaults/product-not-found.webp";
import SpinnerIndicator from "@js/components/Statuses/SpinnerIndicator.vue";

export default {
    name: "ImageLoader",
    components: {SpinnerIndicator},
    props: {
        title: {type: String, required: true},
        src: {type: String, default: null},
        imgClasses: {type: String, default: ""},
    },
    data() {
        return {
            imageLoaded: false,
            imgSrc: this.src || default_img,   // управляемый src
            triedFallback: false,              // защита от зацикливания error
        };
    },
    watch: {
        // при смене src перезапускаем загрузку и сразу проверяем .complete после рендера
        src: {
            immediate: false,
            handler(newVal) {
                this.triedFallback = false;
                this.imageLoaded = false;
                this.imgSrc = newVal || default_img;
                nextTick(() => {
                    const el = this.$refs.imgEl;
                    if (!el) return;
                    // Если уже загружено (особенно из кэша) — событие load не придёт. Отметим руками.
                    if (el.complete && el.naturalWidth > 0) {
                        this.imageLoaded = true;
                    }
                });
            },
        },
    },
    mounted() {
        const el = this.$refs.imgEl;
        if (!el) return;

        // SSR кейс: картинка уже прогружена до гидратации
        if (el.complete) {
            if (el.naturalWidth > 0) {
                this.imageLoaded = true;
            } else {
                // Если complete, но ширина 0 — это ошибка загрузки: сразу применим fallback
                this.onImageError({target: el});
            }
        }
    },
    methods: {
        onImageLoad() {
            this.imageLoaded = true;
        },
        onImageError(e) {
            const el = e?.target || this.$refs.imgEl;
            if (!el) return;

            // защитимся от бесконечного error при fallback
            if (this.triedFallback) {
                this.imageLoaded = true; // прекращаем спиннер даже если ничего не вышло
                return;
            }
            this.triedFallback = true;

            // снимем обработчик error перед подменой, чтобы не зациклиться
            el.onerror = null;
            this.imgSrc = default_img; // используем импортированный ассет, а не хардкод пути
        },
    },
    setup() {
        return {default_img};
    },
};
</script>

<template>
    <div class="relative">
        <img ref="imgEl" :key="imgSrc" :src="imgSrc"
             :alt="title" :title="title"
             :class="[imageLoaded ? '' : 'img-loading', imgClasses]"
             @load="onImageLoad" @error="onImageError"/>
        <div v-if="!imageLoaded" class="absolute inset-0 flex items-center justify-center">
            <SpinnerIndicator class="w-5 h-5 ms-2"/>
        </div>
    </div>
</template>

<style scoped lang="scss">
.img-loading {
    max-width: 0 !important;
    max-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    position: absolute !important;
}
</style>
